<template>
  <div class="question container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <img class="icon" src="@/assets/images/icons/a_question.png" alt="" />
        <div class="mid">
          <p class="title">{{ info.name }}</p>
          <p style="margin-top: 5px">
            <span class="time">{{
              formatDate(info.startTime, "MM-DD HH:mm")
            }}</span>
            <span class="shu">|</span>
            <span class="surplus" v-if="info.status == 'STARTED'"
              >剩余<i class="el-icon-time"></i>{{ surplus }}</span
            >
            <span class="end_tag" v-else>已结束</span>
          </p>
        </div>
      </div>
    </div>
    <div class="main">
      <div
        class="sign_btn"
        v-if="!isQuestion && info.status == 'STARTED'"
        @click="handleQuestion"
      >
        抢答
      </div>
      <div class="list" v-else>
        <p class="my_rank">我的排名：{{ myRank || "无" }}</p>

        <el-table class="rank_list" :data="list">
          <el-table-column prop="top" label="排名" width="100" align="center">
            <template slot-scope="scope">
              <img
                src="@/assets/images/icons/icon_first.png"
                alt
                v-if="scope.row.top == 1"
              />
              <img
                src="@/assets/images/icons/icon_second.png"
                alt
                v-if="scope.row.top == 2"
              />
              <img
                src="@/assets/images/icons/icon_third.png"
                alt
                v-if="scope.row.top == 3"
              />
              <span class="rank_num" v-if="scope.row.top > 3">{{
                scope.row.top
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="avatar"
            label="头像"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 44px; height: 44px"
                :src="scope.row.avatar"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="nickName"
            label="姓名"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="duration" label="抢答时间" align="center">
            <template slot-scope="scope"> {{ scope.row.duration }}秒 </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { answer, answerInfo, answerList } from "@/api/activity/answer";
import { activityInfo } from "@/api/activity";
import { formatDate } from "@/utils/index";
import { dateCount } from "@/utils/index";
export default {
  name: "answer",
  data() {
    return {
      formatDate,
      info: {},
      isQuestion: false,
      surplus: "",
      myRank: null,
      list: [],
    };
  },
  created() {
    this.getInfo();
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  methods: {
    // 活动信息
    getInfo() {
      let activityId = this.$route.query.activityId;
      activityInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.info = res.data;
          let end = new Date(this.info.startTime).getTime();
          let duration = this.info.duration * 60 * 1000;
          end = end + duration;
          let nowTime = +new Date();
          let times = (end - nowTime) / 1000;
          if (times > 0) {
            this.surplus = dateCount(times);
            this.timerId && clearInterval(this.timerId);
            this.timerId = setInterval(() => {
              if (times <= 0 && this.timerId) {
                clearInterval(this.timerId);
                this.getInfo();
              }
              this.surplus = dateCount(times);
              times--;
            }, 1000);
          }
        } else {
          console.log(res.msg);
        }
      });

      answerInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.isQuestion = !!res.data;
          if (this.isQuestion) {
            this.myRank = res.data.top;
            this.getList();
          }
        } else {
          console.log(res.msg);
        }
      });
    },
    // 抢答
    handleQuestion() {
      let activityId = this.$route.query.activityId;
      answer(activityId).then((res) => {
        if (res.code == 0) {
          this.$message.success("抢答成功");
          this.getInfo();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 抢答成员列表
    getList() {
      let activityId = this.$route.query.activityId;
      answerList({ activityId }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.question {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .info {
      position: relative;
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
      vertical-align: middle;
      .icon {
        width: 44px;
        height: 44px;
      }
      .mid {
        display: inline-block;
        margin-left: 20px;
        vertical-align: middle;
      }

      .title {
        font-size: 16px;
        color: #333;
      }
      .time {
        margin-top: 5px;
        color: #999;
        font-size: 14px;
      }

      .shu {
        padding: 0 10px;
        color: #ddd;
      }
      .el-icon-time {
        margin: 0 5px;
      }
      .surplus {
        color: sandybrown;
      }
      .end_tag {
        color: #c8c8c8;
      }
    }
  }
  .main {
    position: relative;
    height: calc(100% - 30px - 20px - 88px - 30px);
    background-color: #fff;
    text-align: left;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    .sign_btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120px;
      height: 120px;
      line-height: 120px;
      background: #1890ff;
      text-align: center;
      font-size: 28px;
      color: #ffffff;
      border-radius: 50%;
      transition: all 0.3s ease;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 0px 10px 0px #1890ff;
      }
    }
    .list {
      .my_rank {
        padding: 20px;
        border-bottom: solid 1px #ddd;
      }
      ::v-deep .rank_list {
        margin-top: 20px;
        padding: 0 20px;
        .is-leaf {
          color: #333;
          background-color: #f5f5f5;
        }

        .rank_num {
          display: inline-block;
          width: 22px;
          height: 22px;
          background: #f0f2f5;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>